export default [
  'Web Development',
  'Mobile Apps',
  'UX & UI Design',
  'Web Design',
  'Consulting',
  'React',
  'Node.js',
  'Software Engineering',
  'Ember',
  'Elixir',
  'Ruby on Rails',
  'D3.js',
];



// WEBPACK FOOTER //
// ./src/app/data/tags/index.js